<template>
    <div class="picture-cropper rounded-2 m-auto">
        <input class="d-none" ref="file" type="file" id="fileName" accept=".jpg,.jpeg,.png" v-on:change="controlDummyImage"/>
        <div class="cropper-container">
            <div v-if="!dummyImage && !picture" v-on:click="$refs.file.click()" class="no-picture-placeholder d-flex flex-column align-items-center justify-content-center">
                <b>{{placeholder}}</b>
                <div class="text-secondary">Yüklemek için tıklayınız.</div>
            </div>
            <img v-on:error="clear" v-if="(!dummyImage && picture)" :src="picture" />
            <cropper v-if="dummyImage" :src="dummyImage" :stencil-props="stencil" @change="change"></cropper>
        </div>
        <div v-if="dummyImage" class="d-flex mt-50">
            <button class="btn btn-sm btn-dark w-100 mr-25" v-on:click="$refs.file.click()">Değiştir</button>
            <button class="btn btn-sm btn-danger w-100 ml-25" v-on:click="clear">Temizle</button>
        </div>
        <div v-if="!dummyImage && picture" class="mt-50">
            <button class="btn btn-sm btn-secondary w-100" v-on:click="dummyImage=picture">Düzenle</button>
        </div>
    </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import randomatic from 'randomatic';

export default {
    components:{
        Cropper
    },
    props: {
        picture: {
            default:null,
        },
        square:{
            type:Boolean,
            default:false
        },
        placeholder:{
            type:String,
            default:"Resim"
        }
    },
    watch:{
        picture(){
            if(typeof this.picture === "string"){
                if(this.dummyImage) this.dummyImage = null
            }
        }
    },
    data() {
        return {
            dummyImage: null,
            image: null,
        }
    },
    methods:{
        controlDummyImage() {
            let file = this.$refs.file.files[0]
            let fileName = this.$refs.file.value
            let idxDot = fileName.lastIndexOf(".") + 1
            let extFile = fileName.substr(idxDot, fileName.length).toLowerCase()
            if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                var reader = new FileReader()
                reader.onload = (e) => {
                    this.dummyImage = e.target.result;
                }
                reader.readAsDataURL(file)
            } else {
                /* Resim Hatası */
            }
        },
        change(cropper) {
            cropper.canvas.toBlob((blob) => {
                this.image = new File([blob],[randomatic("A0",10),"png"].join("."))
                this.$emit("change", this.image)
            },'image/png')
        },
        clear(){
            this.image = null
            this.dummyImage = null
            this.$emit("change", this.image)
        }
    },
    computed:{
        stencil(){
            if(this.square){
                return {aspectRatio : 1/1}
            }else return {}
        }
    }
}
</script>

<style>
.picture-cropper {
    height: fit-content;
    width: 200px;
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0.5rem;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
}

.dark-layout .picture-cropper{
    border-color: #404656;
}

.picture-cropper .cropper-container {
    height: calc(200px - 1rem);
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.picture-cropper .cropper-container img {
    height: 100%;
    width: 100%;
}

.picture-cropper .cropper-container .no-picture-placeholder {
    height: 100%;
    width: 100%;
    border-radius: 0.2rem;
    background-color: rgba(216, 214, 222,0.15);
}

.dark-layout .picture-cropper .cropper-container .no-picture-placeholder {
    background-color: rgba(63, 69, 85, 0.35);
}

.picture-cropper .no-picture-placeholder > div {
    font-size: 12px;
}
</style>